export default {
  title: '{entity1} with active {entity2}',
  searchHelp: 'You can search by {entity1} name or by the {entity2} ID.',
  activeEntity: 'Active {entity}',
  navigation: 'Navigation',
  showEntity: 'Show {entity}',
  hideEntity: 'Hide {entity}',
  code: 'Code',
  noEntity: 'There are no {entity} to show',
  searchEntityPlaceholder: 'Search {entity}...',
  showMore: '+{count} more',
  showLess: 'Show less',
  activeTestTooltip: 'Active {entity}',
  state: 'Status',
  closed: 'Closed',
  inProcess: 'In progress',
  reportsNavigationTooltip: 'Jump to Reports',
}
